import React from 'react';
import './ServicePageHero.css';

const ServicePageHero = ({ breadcrumbLabel, titlePrimary, titleAccent, subtext }) => (
  <section className="service-page-hero">
    <div className="service-page-hero__inner site-rail site-rail--wide">
      <nav className="service-page-hero__breadcrumbs" aria-label="Breadcrumb">
        <a href="/">Home</a>
        <span className="service-page-hero__breadcrumb-sep" aria-hidden="true">
          ›
        </span>
        <a href="/#services">Services</a>
        <span className="service-page-hero__breadcrumb-sep" aria-hidden="true">
          ›
        </span>
        <span className="service-page-hero__breadcrumb-current">{breadcrumbLabel}</span>
      </nav>

      <div className="service-page-hero__content">
        <h1 className="service-page-hero__title">
          <span className="service-page-hero__title-primary">{titlePrimary}</span>
          {titleAccent && <span className="service-page-hero__title-accent">{titleAccent}</span>}
        </h1>
        <p className="service-page-hero__subtext">{subtext}</p>
      </div>
    </div>
  </section>
);

export default ServicePageHero;
